module.exports = __webpack_public_path__ + "static/img/A105.c9ef0fd2.jpg";